<script lang="ts" setup>
import type { ComponentLayoutSimpleHeader } from '@autobid/strapi-integration/graphql/graphql'
import { usePopupStore } from '@autobid/nuxt-pinia-store/store/usePopupStore'
import { storeToRefs } from 'pinia'
import { onBeforeUnmount, onMounted } from 'vue'

const { closePopup, initListener, disableListener } = usePopupStore()
const { activePopups, cmsPopupsData } = storeToRefs(usePopupStore())

onMounted(() => {
  initListener()
})

onBeforeUnmount(() => {
  disableListener()
})
</script>

<template>
  <common-dialog
    v-for="(popup, slug) in activePopups"
    :key="slug"
    :opened="popup"
    :type="cmsPopupsData[slug]?.type"
    :width="cmsPopupsData[slug]?.width"
    @close="() => closePopup(slug)"
  >
    <template #title>
      <p v-if="!cmsPopupsData[slug]">
        {{ $t('loading') }}
      </p>
      <LayoutSimpleHeader
        v-else-if="cmsPopupsData[slug].header"
        class="mr-2"
        :data="(cmsPopupsData[slug].header as ComponentLayoutSimpleHeader)"
      />
      <span v-else />
    </template>

    <template #content>
      <div v-if="cmsPopupsData[slug]" class="-mx-2 -mb-3">
        <CommonStrapiPopupComponents :slug="slug" />
      </div>
    </template>
  </common-dialog>
</template>
